export const extractLogMessage = entry => {
    if (Array.isArray(entry)) {
        if (typeof entry[1] === 'string')
            return entry[1]

        if (typeof entry[0] === 'string')
            return entry[0]

        try {
            return JSON.stringify(entry)
        } catch {
            return String(entry)
        }
    }

    if (typeof entry === 'string')
        return entry

    if (entry && typeof entry === 'object') {
        if (typeof entry.message === 'string')
            return entry.message

        if (typeof entry.text === 'string')
            return entry.text

        try {
            return JSON.stringify(entry)
        } catch {
            return String(entry)
        }
    }

    return typeof entry === 'number' ? String(entry) : ''
}

const normalizeLogTimestamp = value => {
    if (typeof value === 'string' && value.trim() && !Number.isFinite(Number(value))) {
        const parsedDate = Date.parse(value)
        return Number.isFinite(parsedDate) ? parsedDate : undefined
    }

    const numericValue = Number(value)
    if (!Number.isFinite(numericValue) || numericValue <= 0)
        return undefined

    return numericValue < 1_000_000_000_000 ? numericValue * 1000 : numericValue
}

export const extractLogTimestamp = entry => {
    if (Array.isArray(entry))
        return normalizeLogTimestamp(entry[2])

    if (entry && typeof entry === 'object')
        return normalizeLogTimestamp(entry.timestamp ?? entry.createdAt ?? entry.ts)

    return undefined
}

export const formatLocalLogTime = (timestamp, options = {}) => {
    const normalizedTimestamp = normalizeLogTimestamp(timestamp)
    if (!Number.isFinite(normalizedTimestamp))
        return ''

    try {
        return new Intl.DateTimeFormat(options.locales, {
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23',
            ...(options.timeZone ? { timeZone: options.timeZone } : {})
        }).format(new Date(normalizedTimestamp))
    } catch {
        return ''
    }
}

export const localizeLogMessage = (entry, options = {}) => {
    const message = extractLogMessage(entry)
    if (!message)
        return ''

    const localTime = formatLocalLogTime(extractLogTimestamp(entry), options)
    if (!localTime)
        return message

    const timePrefixPattern = /^\[\d{1,2}:\d{2}(?::\d{2})?\]/
    return timePrefixPattern.test(message) ?
        message.replace(timePrefixPattern, `[${localTime}]`) :
        `[${localTime}] ${message}`
}

export const normalizeLogMessages = buffer => {
    if (Array.isArray(buffer))
        return buffer.map(extractLogMessage).filter(Boolean)

    if (typeof buffer === 'string')
        return buffer
            .split(/\r?\n/)
            .map(entry => entry.trimEnd())
            .filter(Boolean)

    const singleMessage = extractLogMessage(buffer)
    return singleMessage ? [singleMessage] : []
}

export const normalizeLocalizedLogMessages = (buffer, options = {}) => {
    if (Array.isArray(buffer))
        return buffer.map(entry => localizeLogMessage(entry, options)).filter(Boolean)

    if (typeof buffer === 'string')
        return buffer
            .split(/\r?\n/)
            .map(entry => entry.trimEnd())
            .filter(Boolean)

    const singleMessage = localizeLogMessage(buffer, options)
    return singleMessage ? [singleMessage] : []
}

export const normalizeLogBuffer = buffer =>
    normalizeLogMessages(buffer).join('\n')

export const mergeLogUpdate = (previousLogs, payload) => ({
    buffer: (payload?.[2]?.append === true ? [
        ...(Array.isArray(previousLogs?.buffer) ? previousLogs.buffer : []),
        ...(Array.isArray(payload?.[0]) ? payload[0] : [])
    ] : (Array.isArray(payload?.[0]) ? payload[0] : [])).slice(-1500),
    count: payload?.[1]
})
